import clc from 'console-log-colors';

import {StorageKeys} from '@core/storage';
import {isDevMode} from '@shared-types';
import {SignalStoreManagerService} from '@shared/signal-store';

import {initSentryConfig} from './sentry.initializer';
import {ApplicationRef} from '@angular/core';

export const initAppConfigurations = async (productionMode: boolean) => {
	localStorage.setItem(StorageKeys.GlobalKeys.ENVIRONMENT, productionMode ? 'production' : 'development');
	initLoggingConfig();
	await initSentryConfig();
	await SignalStoreManagerService.getInstance()?.loadAllSignalStoreIdbTables();
};

const initLoggingConfig = () => {
	if (isDevMode() || isDebugMode()) {
		console.log(clc.green('------------------ Development mode ------------------'));
	} else {
		console.log(clc.red('------------------ Production mode ------------------'));
		// in production enable logs only if StorageKeys.Dev.DEV_MODE is true in local storage
		const devMode = localStorage.getItem(StorageKeys.Dev.DEV_MODE);
		if (devMode === 'true' || isDevMode()) {
			console.log(clc.green('------------------ Development mode ------------------'));
		} else {
			console.log(clc.red('------------------ Production mode ------------------'));
			console.log = () => {};
			console.debug = () => {};
			console.warn = () => {};
			console.error = () => {};
		}
	}
};

export function afterAppBootstrap(applicationRef: ApplicationRef) {
	try {
		if (!isDevMode() && isDebugMode()) {
			// In production mode, we can enable debug mode based on a specific condition
			// we want to enable `ng` tools in	production mode (dev-tools)
			window['ng'] = {
				applicationRef,
				// Retrieves the component instance whose view contains the DOM element.
				getOwningComponent: <T>(elementOrDir: {} | Element): T | null => {
					const component = applicationRef.components.find(comp => comp.location.nativeElement === elementOrDir);
					return component ? (component.instance as T) : null;
				},
				getComponent: <T>(element: Element): T | null => {
					const component = applicationRef.components.find(comp => comp.location.nativeElement.contains(element));
					return component ? (component.instance as T) : null;
				},
			};
		}
	} catch (error) {
		console.error('[AppInitializer] Error during afterAppBootstrap:', error);
	}
}
